import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'hash',
    routes: [
        {
            name: 'default',
            path: '/',
            redirect: 'walletNew/wallet-manage/wallet-bill',
            component: () => import(/* webpackChunkName: 'layout' */ '@/layout'),
            // 包含头尾的页面都写在这里
            children: [
                {
                    path: 'walletNew/balance-manage/add-balance',
                    component: () =>
                        import(
                            /* webpackChunkName: 'walletNew_balanceNew-manage_add-balance' */
                            '@/views/balanceNew/add-balance'
                        )
                },
                {
                    path: 'walletNew/balance-manage/less-balance',
                    component: () =>
                        import(
                            /* webpackChunkName: 'walletNew_balanceNew-manage_less-balance' */
                            '@/views/balanceNew/less-balance'
                        )
                },
                {
                    path: 'walletNew/wallet-manage/wallet-bill',
                    component: () =>
                        import(
                            /* webpackChunkName: 'walletNew_allet-manage_wallet-bill' */
                            '@/views/walletNew/wallet-bill'
                        )
                },
                {
                    path: 'walletNew/wallet-manage/trade-detail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'walletNew_wallet-manage_trade-detail' */
                            '@/views/walletNew/trade-detail'
                        )
                },
                {
                    path: 'walletNew/operationAccount',
                    component: () =>
                        import(
                            /* webpackChunkName: 'walletNew_wallet-operationAccount' */
                            '@/views/walletNew/operationAccount'
                        )
                },
                {
                    path: 'walletNew/modifyPhone',
                    component: () =>
                        import(
                            /* webpackChunkName: 'walletNew_wallet-modifyPhone' */
                            '@/views/walletNew/modifyPhone'
                        )
                },
                {
                    path: 'walletNew/unionAccount',
                    component: () =>
                        import(
                            /* webpackChunkName: 'walletNew_wallet-unionAccount' */
                            '@/views/walletNew/unionAccount'
                        )
                },
                {
                    path: 'walletNew/wallet-manage/credit-bill',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_walletNew-manage_credit-bill' */
                            '@/views/walletNew/credit-bill'
                        )
                },
                {
                    path: 'walletNew/subOperationAccount',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_walletNew-subOperationAccount' */
                            '@/views/walletNew/subOperationAccount'
                        )
                },
                {
                    path: 'walletNew/setting',
                    component: () =>
                        import(
                            /* webpackChunkName: 'walletNew_setting' */
                            '@/views/settingNew'
                        )
                },
                {
                    path: 'walletNew/user/authorization',
                    component: () =>
                        import(
                            /* webpackChunkName: 'walletNew_authorization' */
                            '@/views/authorizationNew'
                        )
                },
                {
                    path: 'walletNew/relateMerchants',
                    component: () =>
                        import(
                            /* webpackChunkName: 'walletNew_relateMerchants' */
                            '@/views/walletNew/relateMerchants'
                        )
                },
                {
                    path: 'walletNew/relateMerchantsDetail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'walletNew_relateMerchantsDetail' */
                            '@/views/walletNew/relateMerchantsDetail'
                        )
                },
                {
                    path: 'walletNew/invoiceApplication',
                    component: () =>
                        import(
                            /* webpackChunkName: 'invoice_application' */
                            '@/views/invoiceApplication'
                        )
                },
                {
                    path: 'walletNew/invoiceApplication/detail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'invoice_applicationDetail' */
                            '@/views/invoiceApplication/detail'
                        )
                },
                {
                    path: 'walletNew/invoiceApplication/records',
                    component: () =>
                        import(
                            /* webpackChunkName: 'invoice_applicationRecords' */
                            '@/views/invoiceApplication/records'
                        )
                },
                {
                    path: 'walletNew/invoiceApplication/apply',
                    component: () =>
                        import(
                            /* webpackChunkName: 'invoice_applicationApply' */
                            '@/views/invoiceApplication/apply'
                        )
                },
                {
                    path: 'walletNew/invoiceApplication/deliverDetail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'invoice_applicationApply' */
                            '@/views/invoiceApplication/deliverDetail'
                        )
                },
                {
                    path: 'walletNew/balance-manage/add-balance-complete',
                    component: () =>
                        import(
                            /* webpackChunkName: 'walletNew_balance-manage_add-balance-complete' */
                            '@/views/balanceNew/add-balance-complete'
                        )
                },
                {
                    path: 'walletNew/setting/modifyPhone',
                    component: () =>
                        import(
                            /* webpackChunkName: 'walletNew_setting' */
                            '@/views/settingNew/modifyPhone'
                        )
                },
                {
                    path: 'walletNew/setting/modifyCard',
                    component: () =>
                        import(
                            /* webpackChunkName: 'walletNew_setting' */
                            '@/views/settingNew/modifyCard'
                        )
                },
                {
                    path: 'merchantNew/transaction',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew' */
                            '@/views/transactionNew'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchantNew/refund',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew_refund' */
                            '@/views/refundNew'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchantNew/settle/order',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew_settleOrder' */
                            '@/views/settleOrderNew'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchantNew/settle/detail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew_settleOrder_detail' */
                            '@/views/settleOrderNew/detail'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchantNew/withdrawal',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew_withdrawal' */
                            '@/views/merchantNew/withdrawal'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchantNew/productCenter',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew_productCenter' */
                            '@/views/merchantNew/productCenter'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchantNew/baseAccount',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew_baseAccount' */
                            '@/views/merchantNew/baseAccount'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchantNew/baseAccountDetail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew_baseAccountDetail' */
                            '@/views/merchantNew/baseAccountDetail'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchantNew/unionAccount',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew_unionAccount' */
                            '@/views/merchantNew/unionAccount'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchantNew/setting',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew_setting' */
                            '@/views/settingNew'
                        )
                },
                {
                    path: 'merchantNew/user/authorization',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew_authorization' */
                            '@/views/authorizationNew'
                        )
                },
                {
                    path: 'merchantNew/relateMerchant',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew_relateMerchant' */
                            '@/views/merchantNew/relateMerchant'
                        )
                },
                {
                    path: 'merchantNew/bindBankAccount',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew_bindBankAccount' */
                            '@/views/merchantNew/bindBankAccount'
                        )
                },
                {
                    path: '/merchantNew/credit/tradeList',
                    component: () => import('@/views/merchantNew/credit/tradeList')
                },
                {
                    path: '/merchantNew/credit/tradeDetail',
                    component: () => import('@/views/merchantNew/credit/tradeDetail')
                },
                {
                    path: '/merchantNew/creditQuota',
                    component: () => import('@/views/merchantNew/credit/quota')
                },
                {
                    path: 'merchantNew/loansAbroad',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew' */
                            '@/views/loanNew/loansAbroad/index'
                        )
                },
                // 结清申请
                {
                    path: 'merchantNew/settle',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew' */
                            '@/views/loanNew/settle/index'
                        )
                },
                // 预期罚息
                {
                    path: 'merchantNew/lateCharge',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew' */
                            '@/views/loanNew/lateCharge/index'
                        )
                },
                // 坏账核销
                {
                    path: 'merchantNew/badDebt',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew' */
                            '@/views/loanNew/badDebt/index'
                        )
                },
                {
                    path: 'merchantNew/subAccountManage',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew' */
                            '@/views/subAccountManageNew/index'
                        )
                },
                {
                    path: 'merchantNew/subAccountManage/detail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew' */
                            '@/views/subAccountManageNew/detail'
                        )
                },
                {
                    path: 'merchantNew/offlinePay',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew' */
                            '@/views/offlinePay/index'
                        )
                },
                {
                    path: 'merchantNew/offlinePayConfig',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew' */
                            '@/views/offlinePay/config'
                        )
                },
                {
                    path: 'merchantNew/orderManage',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew' */
                            '@/views/merchantNew/orderManage'
                        )
                },
                {
                    path: 'merchantNew/orderManageDetail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew' */
                            '@/views/merchantNew/orderManageDetail'
                        )
                },
                {
                    path: 'merchantNew/billDetail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew' */
                            '@/views/merchantNew/billDetail'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchantNew/setting/modifyPhone',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchantNew_setting' */
                            '@/views/settingNew/modifyPhone'
                        )
                },
                {
                    path: 'wallet/balance-manage/add-balance',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_balance-manage_add-balance' */
                            '@/views/balance/add-balance'
                        )
                },
                {
                    path: 'wallet/balance-manage/less-balance',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_balance-manage_less-balance' */
                            '@/views/balance/less-balance'
                        )
                },
                {
                    path: 'wallet/balance-manage/add-balance-complete',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_balance-manage_add-balance-complete' */
                            '@/views/balance/add-balance-complete'
                        )
                },
                {
                    path: 'wallet/wallet-manage/wallet-bill',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_allet-manage_wallet-bill' */
                            '@/views/wallet/wallet-bill'
                        )
                },
                {
                    path: 'wallet/wallet-manage/credit-bill',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_wallet-manage_credit-bill' */
                            '@/views/wallet/credit-bill'
                        )
                },
                {
                    path: 'wallet/wallet-manage/financing-bill',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_wallet-manage_credit-bill' */
                            '@/views/wallet/financing-bill'
                        )
                },
                {
                    path: 'wallet/wallet-manage/trade-detail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_wallet-manage_trade-detail' */
                            '@/views/wallet/trade-detail'
                        )
                },
                {
                    path: 'wallet/operationAccount',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_wallet-manage_trade-detail' */
                            '@/views/wallet/operationAccount'
                        )
                },
                {
                    path: 'wallet/charge',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_wallet-manage_trade-detail' */
                            '@/views/wallet/charge'
                        )
                },
                {
                    path: 'merchant/setting',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_setting' */
                            '@/views/setting'
                        )
                },
                {
                    path: 'wallet/setting',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_setting' */
                            '@/views/setting'
                        )
                },
                {
                    path: 'merchant/setting/modifyPhone',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_setting' */
                            '@/views/setting/modifyPhone'
                        )
                },
                {
                    path: 'wallet/setting/modifyCard',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_setting' */
                            '@/views/setting/modifyCard'
                        )
                },
                {
                    path: 'merchant/setting/modifyPassword',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_setting' */
                            '@/views/setting/modifyPassword'
                        )
                },
                {
                    path: 'wallet/setting/modifyPhone',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_setting' */
                            '@/views/setting/modifyPhone'
                        )
                },
                {
                    path: 'wallet/setting/modifyPassword',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_setting' */
                            '@/views/setting/modifyPassword'
                        )
                },
                {
                    path: 'wallet/license',
                    component: () =>
                        import(
                            /* webpackChunkName: 'wallet_license' */
                            '@/views/license'
                        )
                },
                {
                    path: 'merchant/charge',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/merchant/charge'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/baseAccount',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/merchant/baseAccount'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/baseAccountDetail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/merchant/baseAccountDetail'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/withdrawal',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/merchant/withdrawal'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/operationAccount',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/merchant/operationAccount'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/agree',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/merchant/agree'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/openOperation',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/merchant/components/openOperation'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/openBasic',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/merchant/components/openBasic'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/billDetail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/merchant/billDetail'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'wallet/billDetail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/merchant/billDetail'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/commission',
                    component: () =>
                        import(
                            /* webpackChunkName: 'commission' */
                            '@/views/commission/index'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/commission/detail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'commission' */
                            '@/views/commission/detail'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/commission/config',
                    component: () =>
                        import(
                            /* webpackChunkName: 'commission' */
                            '@/views/commission/config'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/refund',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/refund'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/refund/detail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'refund' */
                            '@/views/refund/detail'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'wallet/refund/detail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'refund' */
                            '@/views/refund/detail'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/transaction',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/transaction'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/transaction/detail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'transaction' */
                            '@/views/transaction/detail'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'wallet/transaction/detail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'transaction' */
                            '@/views/transaction/detail'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/deposit/detail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'transaction' */
                            '@/views/deposit/detail'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'wallet/deposit/detail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'transaction' */
                            '@/views/deposit/detail'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/settle/order',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/settleOrder'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/invoice',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/invoice'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/invoice/detail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/invoice/detail'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/invoice/apply',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/invoice/apply'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: 'merchant/user/authorization',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/authorization'
                        )
                },
                {
                    path: 'wallet/user/authorization',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/authorization'
                        )
                },
                {
                    path: 'merchant/subAccountManage',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/subAccountManage/index'
                        )
                },
                {
                    path: 'merchant/subAccountManage/detail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'subAccountManage' */
                            '@/views/subAccountManage/detail'
                        )
                },
                {
                    path: 'merchant/interestAccount',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/merchant/interestAccount'
                        )
                },
                {
                    path: 'merchant/interestAccountDetail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/merchant/interestAccountDetail'
                        )
                },
                {
                    path: 'merchant/orderManage',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/merchant/orderManage'
                        )
                },
                {
                    path: 'merchant/orderManageDetail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/merchant/orderManageDetail'
                        )
                },
                // 在外货款
                {
                    path: 'merchant/loansAbroad',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/loan/loansAbroad/index'
                        )
                },
                {
                    path: 'merchant/loansAbroad/detail',
                    component: () => import('@/views/loan/loansAbroad/detail')
                },
                // 结清申请
                {
                    path: 'merchant/settle',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/loan/settle/index'
                        )
                },
                // 预期罚息
                {
                    path: 'merchant/lateCharge',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/loan/lateCharge/index'
                        )
                },
                // 坏账核销
                {
                    path: 'merchant/badDebt',
                    component: () =>
                        import(
                            /* webpackChunkName: 'merchant' */
                            '@/views/loan/badDebt/index'
                        )
                },
                {
                    path: 'merchant/badDebt/detail',
                    component: () => import('@/views/loan/badDebt/detail')
                },
                {
                    path: '/merchant/creditQuota',
                    component: () => import('@/views/merchant/credit/quota')
                },
                {
                    path: '/merchant/creditQuotaDetail',
                    component: () => import('@/views/merchant/credit/detail')
                },
                {
                    path: '/merchant/openCredit',
                    component: () => import('@/views/merchant/credit/openCredit')
                },
                {
                    path: '/merchantNew/openCredit',
                    component: () => import('@/views/merchantNew/credit/openCredit')
                },
                {
                    path: '/merchant/credit/tradeList',
                    component: () => import('@/views/merchant/credit/tradeList')
                },
                {
                    path: 'merchantNew/transaction/detail',
                    component: () =>
                        import(
                            /* webpackChunkName: 'transaction' */
                            '@/views/transaction/detail'
                        ),
                    // 不需要登录的页面
                    meta: { auth: false }
                },
                {
                    path: '/merchantNew/creditQuota',
                    component: () => import('@/views/merchantNew/credit/quota')
                },
                {
                    path: '/merchantNew/creditQuotaDetail',
                    component: () => import('@/views/merchantNew/credit/detail')
                },
                {
                    path: '/merchantNew/credit/tradeList',
                    component: () => import('@/views/merchantNew/credit/tradeList')
                }
            ]
        },
        // 不包含头尾的页面都写在这里
        {
            path: '/pay',
            name: 'pay',
            component: () => import(/* webpackChunkName: 'pay' */ '@/views/pay'),
            // 不需要登录的页面
            meta: { auth: false }
        },
        {
            path: '/payNew',
            name: 'payNew',
            component: () => import(/* webpackChunkName: 'pay' */ '@/views/payNew'),
            // 不需要登录的页面
            meta: { auth: false }
        },
        {
            path: '/redirect',
            name: 'redirect',
            component: () => import(/* webpackChunkName: 'redirect' */ '@/views/redirect'),
            // 不需要登录的页面
            meta: { auth: false }
        },
        {
            path: '/error',
            name: 'error',
            component: () => import(/* webpackChunkName: 'error' */ '@/views/error'),
            // 不需要登录的页面
            meta: { auth: false }
        },
        {
            path: '/*',
            redirect: { name: 'error' }
        }
    ]
});
